module.exports = __webpack_public_path__ + "img/roright.008ec3bc.svg";